import React from "react";

function IotmateInput({
  width,
  type = "text",
  placeholder = "",
  value = "",
  onChange,
  disabled = false,
  error = false,
  icon = null,
  label = null
}) {
  const inputStyle = {
    width: width || "100%",
  };

  return (
    <div className="relative" style={{ width: width || "auto" }}>
      {label && (
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && !value && (
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400">
            {icon}
          </div>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`
            border rounded-lg py-2.5 px-4
            transition-all duration-300 ease-in-out
            focus:outline-none focus:ring-2 focus:ring-offset-1
            disabled:bg-gray-100 disabled:cursor-not-allowed
            ${icon && !value ? 'pl-12' : ''}
            ${error
              ? 'border-red-400 focus:border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:border-purple-500 focus:ring-purple-500'
            }
            hover:border-gray-400
            shadow-sm hover:shadow-md
            mr-2
          `}
          style={inputStyle}
        />
      </div>
      {error && typeof error === 'string' && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}

export default IotmateInput;